import { apiFetcher } from '@gjensidige/service-async';

import { selectEnvironment } from './constant';
interface ResponseType {
  calculationStatus: {
    error: false;
  };
  customerName: '';
  adress: '';
  zipCode: '';
  cpr: '';
}
const environment_urls = selectEnvironment();
const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const getAddressDetails = async (validSSN: number) => {
  if (process.env.NODE_ENV !== 'production') {
    await delay(5000);
    if (validSSN == 197110021834)
      return {
        calculationStatus: {
          error: false
        },
        customerName: 'Bengt',
        adress: 'Daliavägen 5',
        zipCode: '73723',
        cpr: '197110021834'
      };
  }
  const url = environment_urls.getAddressURL + '/' + validSSN;
  const response = await apiFetcher.get<ResponseType>(url, {
    cache: 'no-cache',
    headers: {
      Applikasjon: 'GFSEWEBSHOP'
    }
  });
  if (response.isOk()) {
    return response.value;
  }
  return {
    calculationStatus: {
      error: true
    },
    customerName: '',
    adress: '',
    zipCode: '',
    cpr: ''
  };
};
